import { requestJson } from './requestJson';

// One caller for all three deletions, so they cannot drift in how they confirm
// or report. The action is always named explicitly (PD-08).
export async function postAdminDelete(
  action: 'delete-test' | 'delete-creator' | 'delete-reviewer',
  body: Record<string, string>
): Promise<{ deleted: boolean }> {
  return await requestJson(`/api/admin/${action}`, {
    method: 'POST',
    body: JSON.stringify(body)
  });
}
